import React, { useEffect, useState, useContext, useRef } from "react";
import { Container, Box, Typography, Grid, Button } from "@mui/material";
import HomeLayout from "/layouts/HomeLayout";
import { getProductContent } from "context/actions/product";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "context";
import useWindowSize from "utils/useWindowSize";
import Image from "next/image";
import WysiwygViewer from "components/TextEditorViewer";
import MapComponent from "components/MapComponent";
import Link from "next/link";

const Content = ({ newsId }) => {
  const { t } = useTranslation();
  const { state } = useContext(GlobalContext);
  const [data, setData] = useState("");
  const { sizes } = useWindowSize();

  // Refs for sections
  const overviewRef = useRef(null);
  const whatIsRef = useRef(null);
  const itineraryRef = useRef(null);
  const reviewsRef = useRef(null);

  useEffect(() => {
    getPage();
  }, [newsId]);

  const getPage = async () => {
    const res = await getProductContent(newsId);

    if (res.status === "success") {
      setData(res.data);
    }
  };

  const handleScrollTo = (ref) => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  const contactBrochure = () => {};

  const maps = [
    { id: 1, title: "Map 1", url: "https://batbold.travelmap.net" },
    // { id: 2, title: "Map 2", url: "https://another.travelmap.net/share" },
    // { id: 3, title: "Map 3", url: "https://yetanother.travelmap.net/share" },
  ];


  return (
    <Container maxWidth={false} disableGutters>
      {/* Hero Section */}
      <Box
        style={{
          marginTop: 110,
          position: "relative",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          height: sizes.sm ? 439 : 510,
          width: "100%",
          // margin: "0 auto",
          backgroundImage: `url(${data.thumbnail})`,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box className=" text-[62px] text-left mb-4 text-[#fff] font-serif italic">
          {data.title}
        </Box>
      </Box>

      {/* Tabs Section */}
      <Container
        maxWidth="lg"
        disableGutters
        style={{
          display: "flex",
          paddingLeft: !sizes.sm ? 160 : 0,
          paddingRight: !sizes.sm ? 160 : 0,
          marginTop: 20,
          marginBottom: 20,
          // borderBottom: "1px solid gray",
          justifyContent: "space-between",
          zIndex: 9010,
        }}
      ></Container>

      <Container
        maxWidth=""
        disableGutters
        // className="mt-[30px]"
        sx={{
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
        style={{
          padding: "10px", // Ensures spacing when scrolling
        }}
      >
        <Container maxWidth="lg" disableGutters>
          {/* Section Contents */}

          <Box className="flex flex-col md:flex-row gap-4 mt-[20px] mb-[15px]">
            {/* Overview Section */}
            <Box
              ref={overviewRef}
              className="flex-1 p-6  bg-[#eeeeee] shadow rounded-md "
            >
              <Typography
                variant="body14"
                className="!font-bold  mb-4 text-[#545454]"
              >
                Тойм:
              </Typography>
              <Box className="space-y-2 text-sm  text-[#fff] mt-[10px]">
                <Box className="">
                  <Typography className=" flex-shrink-0 text-[#545454] text-[14px]">
                    <span className="font-bold text-[#545454] text-[14px]"> Төрөл:</span>
                    <span> {data.categoryId?.name || "N/A"}</span>
                  </Typography>
                </Box>

                <Box className="">
                  <Typography className="flex-shrink-0 text-[#545454] text-[14px]">
                    <span className="font-bold  text-[14px]">
                      Аяллын хугацаа:
                    </span>
                    <span> {data.time || "N/A"}</span>
                  </Typography>
                </Box>

                <Box className="flex">
                  <span className="font-bold text-[14px] text-[#545454]">Үнэ: </span>
                  <Typography className="ml-2 text-[14px]">
                    {/* {data.price ? ` ${data.price}` : "N/A"} */}
                    <span className="ml-2 text-[#545454]"> {data.price || "N/A"}</span>
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* What’s included Section */}
            <Box
              ref={whatIsRef}
              className="flex-1 p-6 bg-[#eeeeee] shadow rounded-md"
            >
              <Typography
                variant="body14"
                className="!font-bold  text-[#545454] mb-4"
              >
                Аяллын үнэд багтсан зүйлc:
              </Typography>
              <Box className="text-sm text-[#545454]  mt-[10px]">
                <WysiwygViewer data={data.includedData} />
              </Box>
            </Box>

            {/* What to Bring Section */}
            <Box
              ref={reviewsRef}
              className="flex-1 p-6 bg-[#eeeeee] shadow rounded-md"
            >
              <Typography
                variant="body14"
                className="!font-bold  text-[#545454] mb-4"
              >
                Бэлтгэх зүйлс:
              </Typography>
              <Box className="text-sm text-[#545454]  mt-[10px]">
                <WysiwygViewer data={data.bring} />
              </Box>
            </Box>
          </Box>

          {/*  */}
        </Container>
      </Container>
      <Container maxWidth="lg" disableGutters>
        <Box ref={itineraryRef} className="mt-8">
          <Typography
            variant="h18"
            className="font-bold text-[#545454] mb-4 text-center md:text-left"
          >
            Нарийвчилсан маршрут
          </Typography>
          <Container
            maxWidth="lg"
            disableGutters
            className="flex flex-col md:flex-row gap-6 items-start"
          >
            {/* Itinerary Content */}
            <Box className="flex-1 p-4 bg-white shadow rounded-md max-w-full mt-[10px] overflow-auto">
              <WysiwygViewer data={data.content} />
            </Box>

            {/* Map Section */}
          </Container>
        </Box>
      </Container>
    </Container>
  );
};

export async function getServerSideProps(ctx) {
  const newsId = ctx.query.id;
  return {
    props: { newsId },
  };
}

Content.Layout = HomeLayout;

export default Content;
